// extracted by mini-css-extract-plugin
export var active = "_7c-d";
export var blink = "_7c-e";
export var container = "_7c-5";
export var controls = "_7c-0";
export var controlsRight = "_7c-1";
export var fakeCursor = "_7c-c";
export var hidden = "_7c-b";
export var quillContainerSmall = "_7c-7";
export var quillEditor = "_7c-6";
export var quillEditorSmall = "_7c-8";
export var quillFormatButtons = "_7c-a";
export var quillToolbar = "_7c-9";
export var removePadding = "_7c-2";
export var state = "_7c-3";
export var stateTitle = "_7c-4";